import { IFilterSettings } from "Domain/Repository/BaseRepository/BaseRepository";

export const FIND_TAGS_REQUEST = 'FIND_TAGS_REQUEST';

export const findTagsRequest = ({
     filter = [],
     sorting = { field: 'id', order: 'ASC' },
     pagination = { page: 1, take: 50 },
 }: IFilterSettings ) => ({
    type: FIND_TAGS_REQUEST,
    payload: { filter, sorting, pagination },
    meta: {
        sorting,
    }
});
